import React from 'react';

const BreadcumbSeparator = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.44141 14.1914L10.7299 8.9991L7.44141 3.80679"
      stroke="#3C3C3B"
      strokeOpacity="0.5"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
  </svg>
);

BreadcumbSeparator.displayName = 'BreadcumbSeparator';
export default BreadcumbSeparator;
